import {
  IconBusiness,
  IconDashBoard,
  IconDollar,
  IconFlight,
  IconHome,
  IconHotelOutLine,
  IconInfoAgency,
  IconMyNotification,
  IconMyReview,
  IconSearch,
  IconTeamOutline,
  IconUser,
  IconWallet,
} from "../components/icons";

export const PATH_USER = {
  DASHBOARD: "/tai-khoan/dashboard",

  HOTEL: "/tai-khoan/dat-phong",
  HOTEL_DETAIL: "/tai-khoan/dat-phong/[id]",
  FLIGHT: "/tai-khoan/chuyen-bay",
  FLIGHT_DETAIL: "/tai-khoan/chuyen-bay/[id]",
  COMBO: "/tai-khoan/combo",
  COMBO_DETAIL: "/tai-khoan/combo/[id]",
  COUPON: "/tai-khoan/coupon",
  VOUCHER: "/tai-khoan/voucher",
  VOUCHER_DETAIL: "/tai-khoan/voucher/[code]",
  ACTIVITY: "/tai-khoan/hoat-dong",
  REVIERW: "/tai-khoan/danh-gia",
  INVOICE: "/tai-khoan/hoa-don",
  CARD: "/tai-khoan/the-thanh-vien",
  NOTIFICATION: "/tai-khoan/thong-bao",
  HISTORY_TRANSACTION: "/tai-khoan/lich-su-giao-dich",
  AGENCY: "/tai-khoan/thong-tin-dai-ly",
  COMMISSION: "/tai-khoan/cau-hinh-hoa-hong",
  CUSTOMER_MANAGEMENT: "/tai-khoan/khach-hang",
};

export const SIDEBAR_PROFILE_V2 = [
  {
    key: "/profile",
    label: "Thông tin cá nhân",
    path: `/profile`,
    icon: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M21.2805 18.7359C20.7752 17.5391 20.042 16.4519 19.1216 15.535C18.204 14.6155 17.117 13.8824 15.9207 13.3761C15.91 13.3708 15.8993 13.3681 15.8885 13.3627C17.5573 12.1574 18.6421 10.194 18.6421 7.9788C18.6421 4.30915 15.6689 1.33594 11.9993 1.33594C8.32962 1.33594 5.3564 4.30915 5.3564 7.9788C5.3564 10.194 6.44122 12.1574 8.10997 13.3654C8.09926 13.3708 8.08855 13.3734 8.07783 13.3788C6.87783 13.885 5.80105 14.6109 4.87694 15.5377C3.95741 16.4553 3.22427 17.5423 2.71801 18.7386C2.22066 19.9098 1.95243 21.1655 1.92783 22.4377C1.92712 22.4663 1.93213 22.4948 1.94258 22.5214C1.95303 22.548 1.9687 22.5723 1.98867 22.5927C2.00864 22.6132 2.0325 22.6295 2.05886 22.6406C2.08521 22.6517 2.11352 22.6574 2.14212 22.6574H3.74926C3.86712 22.6574 3.96087 22.5636 3.96355 22.4484C4.01712 20.3806 4.84747 18.444 6.31533 16.9761C7.83408 15.4574 9.85105 14.6217 11.9993 14.6217C14.1475 14.6217 16.1644 15.4574 17.6832 16.9761C19.151 18.444 19.9814 20.3806 20.035 22.4484C20.0377 22.5663 20.1314 22.6574 20.2493 22.6574H21.8564C21.885 22.6574 21.9133 22.6517 21.9397 22.6406C21.966 22.6295 21.9899 22.6132 22.0099 22.5927C22.0298 22.5723 22.0455 22.548 22.0559 22.5214C22.0664 22.4948 22.0714 22.4663 22.0707 22.4377C22.0439 21.1574 21.7787 19.9118 21.2805 18.7359ZM11.9993 12.5859C10.7698 12.5859 9.61265 12.1065 8.74212 11.2359C7.87158 10.3654 7.39212 9.20826 7.39212 7.9788C7.39212 6.74933 7.87158 5.59219 8.74212 4.72165C9.61265 3.85112 10.7698 3.37165 11.9993 3.37165C13.2287 3.37165 14.3859 3.85112 15.2564 4.72165C16.1269 5.59219 16.6064 6.74933 16.6064 7.9788C16.6064 9.20826 16.1269 10.3654 15.2564 11.2359C14.3859 12.1065 13.2287 12.5859 11.9993 12.5859Z"
          fill="#434343"
        />
      </svg>
    ),
    role: [],
  },
  {
    key: "/profile/signin-info",
    label: "Thông tin đăng nhập",
    path: `/profile/signin-info`,
    icon: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M20.5713 10.7176H18.7499V4.71763C18.7499 2.82388 17.215 1.28906 15.3213 1.28906H8.67843C6.78468 1.28906 5.24986 2.82388 5.24986 4.71763V10.7176H3.42843C2.95432 10.7176 2.57129 11.1007 2.57129 11.5748V21.8605C2.57129 22.3346 2.95432 22.7176 3.42843 22.7176H20.5713C21.0454 22.7176 21.4284 22.3346 21.4284 21.8605V11.5748C21.4284 11.1007 21.0454 10.7176 20.5713 10.7176ZM7.17843 4.71763C7.17843 3.88996 7.85075 3.21763 8.67843 3.21763H15.3213C16.149 3.21763 16.8213 3.88996 16.8213 4.71763V10.7176H7.17843V4.71763ZM19.4999 20.7891H4.49986V12.6462H19.4999V20.7891ZM11.2499 17.0658V18.4855C11.2499 18.6033 11.3463 18.6998 11.4641 18.6998H12.5356C12.6534 18.6998 12.7499 18.6033 12.7499 18.4855V17.0658C12.971 16.9071 13.136 16.6823 13.2212 16.4238C13.3064 16.1653 13.3074 15.8864 13.224 15.6273C13.1406 15.3682 12.9772 15.1422 12.7572 14.9819C12.5372 14.8216 12.2721 14.7352 11.9999 14.7352C11.7277 14.7352 11.4625 14.8216 11.2425 14.9819C11.0225 15.1422 10.8591 15.3682 10.7757 15.6273C10.6923 15.8864 10.6933 16.1653 10.7785 16.4238C10.8637 16.6823 11.0288 16.9071 11.2499 17.0658V17.0658Z"
          fill="black"
          fillOpacity="0.85"
        />
      </svg>
    ),
    role: [],
    divider: true,
  },
  {
    key: "/profile/wallet",
    label: "Ví của bạn",
    path: `/profile/wallet`,
    icon: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M21.8568 1.28906H2.14254C1.66844 1.28906 1.2854 1.6721 1.2854 2.14621V21.8605C1.2854 22.3346 1.66844 22.7176 2.14254 22.7176H21.8568C22.3309 22.7176 22.714 22.3346 22.714 21.8605V2.14621C22.714 1.6721 22.3309 1.28906 21.8568 1.28906ZM20.7854 13.7176H12.4283V10.2891H20.7854V13.7176ZM20.7854 20.7891H3.21397V3.21763H20.7854V8.57478H11.5711C11.097 8.57478 10.714 8.95781 10.714 9.43192V14.5748C10.714 15.0489 11.097 15.4319 11.5711 15.4319H20.7854V20.7891ZM13.8211 12.0033C13.8211 12.2875 13.934 12.56 14.1349 12.761C14.3359 12.9619 14.6084 13.0748 14.8925 13.0748C15.1767 13.0748 15.4492 12.9619 15.6502 12.761C15.8511 12.56 15.964 12.2875 15.964 12.0033C15.964 11.7192 15.8511 11.4467 15.6502 11.2457C15.4492 11.0448 15.1767 10.9319 14.8925 10.9319C14.6084 10.9319 14.3359 11.0448 14.1349 11.2457C13.934 11.4467 13.8211 11.7192 13.8211 12.0033Z"
          fill="#434343"
        />
      </svg>
    ),
    role: [],
  },
  {
    key: "tai-khoan/thong-tin-dai-ly",
    label: "Thông tin Đại lý hạng Bạc",
    path: process.env.REACT_APP_URL_ATADI + PATH_USER.AGENCY,
    icon: () => <IconInfoAgency />,
    role: ["agency"],
  },
  {
    key: "tai-khoan/thong-tin-dai-ly",
    label: "Thông tin Đại lý hạng Vàng",
    path: process.env.REACT_APP_URL_ATADI + PATH_USER.AGENCY,
    icon: () => <IconInfoAgency />,
    role: ["general_agency"],
  },
  {
    key: "tai-khoan/cau-hinh-hoa-hong",
    label: "Cấu hình hoa hồng",
    path: process.env.REACT_APP_URL_ATADI + PATH_USER.COMMISSION,
    icon: () => <IconDollar />,
    role: ["agency", "general_agency"],
  },

  // {
  //   key: "/tai-khoan/dashboard",
  //   label: "Dashboard",
  //   path: `${process.env.REACT_APP_URL_ATADI}${PATH_USER.DASHBOARD}`,
  //   icon: () => (
  //     <svg
  //       xmlns="http://www.w3.org/2000/svg"
  //       width="24"
  //       height="24"
  //       viewBox="0 0 24 24"
  //       fill="none"
  //     >
  //       <g clipPath="url(#clip0_1033_17526)">
  //         <path
  //           d="M23.0571 8.61763C22.4548 7.19185 21.5815 5.89649 20.4857 4.80335C19.3926 3.70757 18.0972 2.83429 16.6714 2.23192C15.1902 1.60513 13.6205 1.28906 12 1.28906C10.3795 1.28906 8.80982 1.60513 7.32857 2.23192C5.90279 2.83429 4.60743 3.70757 3.51429 4.80335C2.4185 5.89649 1.54523 7.19185 0.942857 8.61763C0.316071 10.0989 0 11.6685 0 13.2891C0 16.8435 1.56161 20.1917 4.28304 22.4792L4.32857 22.5167C4.48393 22.6453 4.67946 22.7176 4.88036 22.7176H19.1223C19.3232 22.7176 19.5187 22.6453 19.6741 22.5167L19.7196 22.4792C22.4384 20.1917 24 16.8435 24 13.2891C24 11.6685 23.6812 10.0989 23.0571 8.61763ZM18.6804 20.6819H5.31964C4.28463 19.7487 3.45741 18.6083 2.89167 17.3346C2.32593 16.061 2.0343 14.6827 2.03571 13.2891C2.03571 10.6266 3.07232 8.12478 4.95536 6.24442C6.83839 4.36138 9.34018 3.32478 12 3.32478C14.6625 3.32478 17.1643 4.36138 19.0446 6.24442C20.9277 8.12746 21.9643 10.6292 21.9643 13.2891C21.9643 16.1176 20.7723 18.7935 18.6804 20.6819ZM14.9866 9.57924C14.9463 9.53936 14.8919 9.51699 14.8353 9.51699C14.7786 9.51699 14.7242 9.53936 14.6839 9.57924L12.4205 11.8426C11.9196 11.7087 11.3652 11.8373 10.9714 12.231C10.832 12.3702 10.7213 12.5356 10.6458 12.7176C10.5703 12.8996 10.5315 13.0947 10.5315 13.2917C10.5315 13.4888 10.5703 13.6839 10.6458 13.8659C10.7213 14.0479 10.832 14.2133 10.9714 14.3525C11.1106 14.4919 11.276 14.6026 11.458 14.6781C11.64 14.7535 11.8351 14.7924 12.0321 14.7924C12.2292 14.7924 12.4243 14.7535 12.6063 14.6781C12.7883 14.6026 12.9537 14.4919 13.0929 14.3525C13.2794 14.1665 13.4136 13.9345 13.4818 13.6801C13.55 13.4256 13.5498 13.1577 13.4812 12.9033L15.7446 10.64C15.8277 10.5569 15.8277 10.4203 15.7446 10.3373L14.9866 9.57924ZM11.4107 6.86049H12.5893C12.7071 6.86049 12.8036 6.76406 12.8036 6.64621V4.50335C12.8036 4.38549 12.7071 4.28906 12.5893 4.28906H11.4107C11.2929 4.28906 11.1964 4.38549 11.1964 4.50335V6.64621C11.1964 6.76406 11.2929 6.86049 11.4107 6.86049ZM18.375 12.6998V13.8783C18.375 13.9962 18.4714 14.0926 18.5893 14.0926H20.7321C20.85 14.0926 20.9464 13.9962 20.9464 13.8783V12.6998C20.9464 12.5819 20.85 12.4855 20.7321 12.4855H18.5893C18.4714 12.4855 18.375 12.5819 18.375 12.6998ZM18.7152 7.41763L17.8821 6.5846C17.8419 6.54472 17.7875 6.52235 17.7308 6.52235C17.6741 6.52235 17.6197 6.54472 17.5795 6.5846L16.0634 8.10067C16.0235 8.14094 16.0011 8.19533 16.0011 8.25201C16.0011 8.30869 16.0235 8.36307 16.0634 8.40335L16.8964 9.23638C16.9795 9.31942 17.1161 9.31942 17.1991 9.23638L18.7152 7.72031C18.7982 7.63728 18.7982 7.50067 18.7152 7.41763ZM6.43125 6.5846C6.39098 6.54472 6.33659 6.52235 6.27991 6.52235C6.22323 6.52235 6.16885 6.54472 6.12857 6.5846L5.29554 7.41763C5.25566 7.45791 5.23329 7.5123 5.23329 7.56897C5.23329 7.62565 5.25566 7.68004 5.29554 7.72031L6.81161 9.23638C6.89464 9.31942 7.03125 9.31942 7.11429 9.23638L7.94732 8.40335C8.03036 8.32031 8.03036 8.18371 7.94732 8.10067L6.43125 6.5846ZM5.30357 12.4855H3.16071C3.04286 12.4855 2.94643 12.5819 2.94643 12.6998V13.8783C2.94643 13.9962 3.04286 14.0926 3.16071 14.0926H5.30357C5.42143 14.0926 5.51786 13.9962 5.51786 13.8783V12.6998C5.51786 12.5819 5.42143 12.4855 5.30357 12.4855Z"
  //           fill="#434343"
  //         />
  //       </g>
  //       <defs>
  //         <clipPath id="clip0_1033_17526">
  //           <rect width="24" height="24" fill="white" />
  //         </clipPath>
  //       </defs>
  //     </svg>
  //   ),
  //   role: [],
  //   blank: true,
  // },

  {
    key: "tai-khoan/dat-phong",
    label: "Quản lý đơn hàng",
    path: `${process.env.REACT_APP_URL_ATADI}${PATH_USER.HOTEL}`,
    icon: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        className="flex-shrink-0"
      >
        <path
          d="M16.3933 13.423C15.0326 13.423 13.929 14.5266 13.929 15.8873C13.929 17.248 15.0326 18.3516 16.3933 18.3516C17.754 18.3516 18.8576 17.248 18.8576 15.8873C18.8576 14.5266 17.754 13.423 16.3933 13.423ZM16.3933 16.798C15.8897 16.798 15.4826 16.3908 15.4826 15.8873C15.4826 15.3837 15.8897 14.9766 16.3933 14.9766C16.8968 14.9766 17.304 15.3837 17.304 15.8873C17.304 16.3908 16.8968 16.798 16.3933 16.798ZM21.8576 2.78906H16.179C16.179 1.96138 15.5067 1.28906 14.679 1.28906H12.5361C11.7085 1.28906 11.0361 1.96138 11.0361 2.78906H5.35756C4.88345 2.78906 4.50042 3.1721 4.50042 3.64621V9.00335H2.14328C1.66917 9.00335 1.28613 9.38638 1.28613 9.86049V21.8605C1.28613 22.3346 1.66917 22.7176 2.14328 22.7176H11.1433C11.6174 22.7176 12.0004 22.3346 12.0004 21.8605V21.4319H21.8576C22.3317 21.4319 22.7147 21.0489 22.7147 20.5748V3.64621C22.7147 3.1721 22.3317 2.78906 21.8576 2.78906ZM10.8218 4.50335H12.7504V3.00335H14.4647V4.50335H16.3933V5.78906H10.8218V4.50335ZM10.2861 21.0033H3.00042V14.7891H10.2861V21.0033ZM10.2861 13.0748H3.00042V10.7176H10.2861V13.0748ZM20.7861 19.5033H12.0004V9.86049C12.0004 9.38638 11.6174 9.00335 11.1433 9.00335H6.42899V4.71763H9.10756V7.50335H18.1076V4.71763H20.7861V19.5033ZM17.1433 9.21763V11.7891C17.1433 11.9069 17.2397 12.0033 17.3576 12.0033H18.6433C18.7611 12.0033 18.8576 11.9069 18.8576 11.7891V9.21763C18.8576 9.09978 18.7611 9.00335 18.6433 9.00335H17.3576C17.2397 9.00335 17.1433 9.09978 17.1433 9.21763ZM14.1433 12.0033H15.429C15.5468 12.0033 15.6433 11.9069 15.6433 11.7891V10.2891C15.6433 10.1712 15.5468 10.0748 15.429 10.0748H14.1433C14.0254 10.0748 13.929 10.1712 13.929 10.2891V11.7891C13.929 11.9069 14.0254 12.0033 14.1433 12.0033Z"
          fill="#434343"
        />
      </svg>
    ),
    role: [],
    blank: true,
    children: [
      {
        key: "tai-khoan/dat-phong",
        label: "Khách sạn",
        path: `${process.env.REACT_APP_URL_ATADI}${PATH_USER.HOTEL}`,
      },
      {
        key: "tai-khoan/chuyen-bay",
        label: "Vé máy bay",
        path: `${process.env.REACT_APP_URL_ATADI}${PATH_USER.FLIGHT}`,
      },
    ],
  },
  {
    key: "tai-khoan/khach-hang",
    label: "Quản lý khách hàng",
    path: `${process.env.REACT_APP_URL_ATADI}${PATH_USER.CUSTOMER_MANAGEMENT}`,
    icon: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
      >
        <path
          d="M19.363 16.037C18.6925 15.366 17.9091 14.8184 17.0487 14.4192C18.2621 13.4361 19.0362 11.9361 19.0362 10.254C19.0362 7.28612 16.5612 4.8513 13.5933 4.89683C10.671 4.94237 8.31656 7.32362 8.31656 10.254C8.31656 11.9361 9.09334 13.4361 10.3041 14.4192C9.44345 14.8181 8.66 15.3658 7.98977 16.037C6.52727 17.5022 5.69691 19.4361 5.64334 21.4986C5.64263 21.5272 5.64764 21.5557 5.65809 21.5823C5.66854 21.6089 5.68421 21.6332 5.70418 21.6536C5.72415 21.6741 5.74801 21.6904 5.77437 21.7015C5.80072 21.7126 5.82903 21.7183 5.85763 21.7183H7.35763C7.47281 21.7183 7.56924 21.6272 7.57191 21.512C7.62281 19.9584 8.25227 18.504 9.35852 17.4004C9.92461 16.8313 10.5979 16.3801 11.3396 16.073C12.0812 15.7659 12.8764 15.6089 13.6791 15.6111C15.3103 15.6111 16.8451 16.2459 17.9996 17.4004C19.1032 18.504 19.7326 19.9584 19.7862 21.512C19.7889 21.6272 19.8853 21.7183 20.0005 21.7183H21.5005C21.5291 21.7183 21.5574 21.7126 21.5837 21.7015C21.6101 21.6904 21.634 21.6741 21.6539 21.6536C21.6739 21.6332 21.6896 21.6089 21.7 21.5823C21.7105 21.5557 21.7155 21.5272 21.7148 21.4986C21.6612 19.4361 20.8308 17.5022 19.363 16.037ZM13.6791 13.6825C12.763 13.6825 11.9005 13.3263 11.2549 12.6781C10.931 12.3567 10.6751 11.9733 10.5025 11.5508C10.3299 11.1284 10.2442 10.6755 10.2505 10.2192C10.2585 9.34058 10.6094 8.49148 11.2228 7.86201C11.8657 7.20308 12.7255 6.83612 13.6442 6.82541C14.5523 6.81737 15.4335 7.17094 16.0817 7.80576C16.746 8.45666 17.1103 9.32719 17.1103 10.254C17.1103 11.17 16.7541 12.0299 16.1058 12.6781C15.7878 12.9976 15.4096 13.2509 14.993 13.4233C14.5765 13.5958 14.1299 13.6839 13.6791 13.6825ZM6.96924 10.9611C6.94513 10.7281 6.93174 10.4924 6.93174 10.254C6.93174 9.82808 6.97191 9.41291 7.04691 9.00844C7.06566 8.91201 7.01477 8.81291 6.92638 8.77273C6.56209 8.60933 6.22727 8.38433 5.93799 8.10041C5.59711 7.76989 5.32887 7.37195 5.15039 6.93197C4.97191 6.49199 4.8871 6.01964 4.90138 5.54505C4.92549 4.68523 5.27102 3.86826 5.8737 3.25219C6.53531 2.57451 7.42459 2.20487 8.37013 2.21558C9.22459 2.22362 10.0496 2.55308 10.6737 3.13701C10.8853 3.33523 11.0675 3.55487 11.2201 3.79058C11.2737 3.87362 11.3782 3.90844 11.4692 3.8763C11.9407 3.71291 12.4389 3.59773 12.9505 3.54416C13.1005 3.52808 13.1862 3.36737 13.1192 3.23344C12.2487 1.51112 10.4701 0.321834 8.41299 0.289691C5.44245 0.244155 2.96745 2.67898 2.96745 5.64416C2.96745 7.3263 3.74156 8.8263 4.95495 9.80933C4.10316 10.2031 3.31834 10.7468 2.63799 11.4272C1.17013 12.8924 0.339771 14.8263 0.2862 16.8915C0.285485 16.9201 0.290499 16.9485 0.300948 16.9751C0.311396 17.0017 0.327067 17.026 0.347037 17.0465C0.367006 17.0669 0.390872 17.0832 0.417225 17.0943C0.443579 17.1054 0.471889 17.1111 0.500486 17.1111H2.00316C2.11834 17.1111 2.21477 17.02 2.21745 16.9049C2.26834 15.3513 2.89781 13.8968 4.00406 12.7933C4.79156 12.0058 5.75584 11.4593 6.80852 11.1942C6.91299 11.1674 6.98263 11.0683 6.96924 10.9611Z"
          fill="#434343"
        />
      </svg>
    ),
    role: [],
    blank: true,
  },
  {
    key: "tai-khoan/danh-gia",
    label: "Quản lý đánh giá",
    path: `${process.env.REACT_APP_URL_ATADI}${PATH_USER.REVIERW}`,
    blank: true,
    icon: () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M6.21443 4.97712C6.09657 4.97712 6.00014 5.07355 6.00014 5.19141V6.47712C6.00014 6.59498 6.09657 6.69141 6.21443 6.69141H16.5001C16.618 6.69141 16.7144 6.59498 16.7144 6.47712V5.19141C16.7144 5.07355 16.618 4.97712 16.5001 4.97712H6.21443ZM11.143 8.83426H6.21443C6.09657 8.83426 6.00014 8.93069 6.00014 9.04855V10.3343C6.00014 10.4521 6.09657 10.5485 6.21443 10.5485H11.143C11.2609 10.5485 11.3573 10.4521 11.3573 10.3343V9.04855C11.3573 8.93069 11.2609 8.83426 11.143 8.83426ZM9.85728 21.1021H3.85728V2.24498H18.8573V10.8164C18.8573 10.9343 18.9537 11.0307 19.0716 11.0307H20.5716C20.6894 11.0307 20.7859 10.9343 20.7859 10.8164V1.17355C20.7859 0.699442 20.4028 0.316406 19.9287 0.316406H2.78585C2.31175 0.316406 1.92871 0.699442 1.92871 1.17355V22.1736C1.92871 22.6477 2.31175 23.0307 2.78585 23.0307H9.85728C9.97514 23.0307 10.0716 22.9343 10.0716 22.8164V21.3164C10.0716 21.1986 9.97514 21.1021 9.85728 21.1021ZM21.643 18.745H17.7859V17.7646C19.026 17.395 19.9287 16.2486 19.9287 14.8878C19.9287 13.2298 18.5867 11.8878 16.9287 11.8878C15.2707 11.8878 13.9287 13.2298 13.9287 14.8878C13.9287 16.2459 14.8314 17.395 16.0716 17.7646V18.745H12.2144C11.9787 18.745 11.7859 18.9378 11.7859 19.1735V23.245C11.7859 23.4807 11.9787 23.6736 12.2144 23.6736H21.643C21.8787 23.6736 22.0716 23.4807 22.0716 23.245V19.1735C22.0716 18.9378 21.8787 18.745 21.643 18.745ZM15.5894 14.8878C15.5894 14.1486 16.1894 13.5486 16.9287 13.5486C17.668 13.5486 18.268 14.1486 18.268 14.8878C18.268 15.6271 17.668 16.2271 16.9287 16.2271C16.1894 16.2271 15.5894 15.6271 15.5894 14.8878ZM20.4109 22.0128H13.4466V20.4057H20.4109V22.0128Z"
          fill="#434343"
        />
      </svg>
    ),
    role: [],
  },
  // {
  //   key: "tai-khoan/thong-bao",
  //   label: "Thông báo của bạn ",
  //   path: `${process.env.REACT_APP_URL_ATADI}${PATH_USER.NOTIFICATION}`,
  //   icon: () => (
  //     <svg
  //       xmlns="http://www.w3.org/2000/svg"
  //       width="24"
  //       height="24"
  //       viewBox="0 0 24 24"
  //       fill="none"
  //     >
  //       <path
  //         d="M21.8576 1.28906C21.7558 1.28906 21.6513 1.30781 21.5469 1.35067L6.10756 7.55424H1.7147C1.47899 7.55424 1.28613 7.75246 1.28613 7.99888V16.0078C1.28613 16.2542 1.47899 16.4525 1.7147 16.4525H4.43881C4.3397 16.7632 4.28613 17.0926 4.28613 17.4275C4.28613 19.1926 5.7272 20.6283 7.50042 20.6283C8.98435 20.6283 10.2352 19.6212 10.6049 18.2605L21.5495 22.6587C21.654 22.6989 21.7585 22.7203 21.8602 22.7203C22.3129 22.7203 22.7174 22.34 22.7174 21.831V2.17835C22.7147 1.66942 22.3129 1.28906 21.8576 1.28906ZM7.50042 18.7078C6.7906 18.7078 6.2147 18.1346 6.2147 17.4275C6.2147 17.1275 6.31917 16.8408 6.50935 16.6132L8.78345 17.5266C8.72988 18.1855 8.17542 18.7078 7.50042 18.7078ZM20.7861 20.2721L6.82542 14.6632L6.47988 14.5239H3.2147V9.48281H6.47988L6.82542 9.34353L20.7861 3.7346V20.2721Z"
  //         fill="#434343"
  //       />
  //     </svg>
  //   ),
  //   role: [],
  // },
];

export const LIST_ROUTER_MENU_MOBILE = [
  {
    key: "home",
    label: "Trang chủ",
    link: `${process.env.REACT_APP_URL_ATADI}`,
    translate: "home",
    isOpenNewTab: false,
    icon: () => <IconHome />,
  },
  {
    key: "hotel",
    label: "Khách sạn",
    link: `${process.env.REACT_APP_URL_ATADI}/khach-san`,
    translate: "hotel",
    isOpenNewTab: false,
    icon: () => <IconHotelOutLine />,
  },
  {
    key: "flight",
    label: "Vé máy bay",
    link: `${process.env.REACT_APP_URL_ATADI}/ve-may-bay`,
    translate: "flight",
    isOpenNewTab: false,
    icon: () => <IconFlight />,
  },
  {
    key: "search order",
    label: "Tra cứu đơn hàng",
    link: `${process.env.REACT_APP_URL_ATADI}/tra-cuu-don-hang`,
    translate: "common",
    isOpenNewTab: false,
    icon: () => <IconSearch />,
  },
];

export const LIST_LINK_PROFILE = [
  {
    link: `/profile`,
    openNewTab: true,
    label: "Thông tin cá nhân",
    icon: <IconUser />,
    role: [],
  },
  {
    link: `${process.env.REACT_APP_URL_ATADI}${PATH_USER.AGENCY}`,
    openNewTab: false,
    label: "Thông tin Đại lý hạng Bạc",
    icon: <IconInfoAgency />,
    role: ["agency"],
  },
  {
    link: `${process.env.REACT_APP_URL_ATADI}${PATH_USER.AGENCY}`,
    openNewTab: false,
    label: "Thông tin Đại lý hạng Vàng",
    icon: <IconInfoAgency />,
    role: ["general_agency"],
  },
  {
    link: `${process.env.REACT_APP_URL_ATADI}${PATH_USER.COMMISSION}`,
    openNewTab: false,
    label: "Cấu hình hoa hồng",
    icon: <IconDollar />,
    role: ["agency", "general_agency"],
  },
  {
    link: `/profile/wallet`,
    openNewTab: true,
    label: "Ví của bạn",
    icon: <IconWallet />,
    role: [],
    border: true,
  },
  // {
  //   link: `${process.env.REACT_APP_URL_ATADI}${PATH_USER.DASHBOARD}`,
  //   label: "Dashboard",
  //   icon: <IconDashBoard />,
  //   role: [],
  // },
  {
    label: "Quản lý khách hàng",
    link: `${process.env.REACT_APP_URL_ATADI}${PATH_USER.CUSTOMER_MANAGEMENT}`,
    icon: <IconTeamOutline />,
    role: [],
    border: true,
  },
  {
    link: `${process.env.REACT_APP_URL_ATADI}${PATH_USER.REVIERW}`,
    label: "Quản lý đánh giá",
    icon: <IconMyReview />,
    role: [],
    border: true,
  },
  // {
  //   link: PATH_USER.NOTIFICATION,
  //   label: "Thông báo của bạn",
  //   icon: <IconMyNotification />,
  //   role: [],
  //   border: true,
  // },
];
